module.exports = __webpack_public_path__ + "static/media/telegram.4df45767.png";